import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-process-and-display-study-id',
    templateUrl: './MED-process-and-display-research-study-id.component.html',
    styleUrls: ['./MED-process-and-display-research-study-id.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MEDResearchStudyIDComponent {
    @Input() studyId: Array<string> = [];
    @Input() titleKey: string;
    @Input() placeholder: string;
    @Input() isFilesPage: boolean;
    @Input() studyIdValue?: string;

    @Output() createStudyId = new EventEmitter<string>();

    onCreateStudyId(studyId: string): void {
        this.createStudyId.emit(studyId);
    }

    isStudyIDInputField(): boolean {
        return this.titleKey === 'studyId';
    }
}
